import React, { Component } from "react";
import {
  Row,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody,
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy, { addValidationRule } from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";

import InterestDropdown from "../Interests/InterestDropdown";
import { PhoneInput } from "../../Shared/Forms/PhoneInput";
import "../../Shared/Forms/form.css";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

addValidationRule("PhoneNumber", function(values, value) {
  if (!value) {
    return true;
  } else {
    return /^(\+?)(\d{7,13})$/.test(value);
  }
});
class InstructorForm extends Component {
  state = {
    canSubmit: false,
    countryCode: null,
    run: false,
    stepIndex: 0,
    steps: [
      {
        target: tourMessages.adminInstructorForm.target,
        content: (
          <div>
            <p>{tourMessages.adminInstructorForm.title}</p>
          </div>
        ),
        placement:  "left",
        locale: { skip: "SKIP" , close: 'Next'},
      },
      tourMessages.default,
    ],
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSucessful) {
      this.resetForm();
    }
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }

  createRequest = data => {
    let request = { ...data };

    if (request.interestsIds && request.interestsIds.length) {
      const arrayOfIds = request.interestsIds.map(interest => interest.id);

      request = {
        interests: arrayOfIds,
        ...request,
      };
      delete request.interestsIds;
    }
    return request;
  };

  getCountryCode = code => {
    this.setState({
      countryCode: code,
    });
  };

  resetForm = () => {
    this.refs.instructorForm.reset();
    if (this.interestRef) {
      this.interestRef.interests.changeValue(null);
    }
  };

  ClearAll = () => {
    this.props.reset();
    this.resetForm();
  };

  handleSubmit = data => {
    let mobileNumber = null;
    let countryCodes = null;

    let dataArray = [];

    if (data.mobileNumber.includes("+")) {
      mobileNumber = data.mobileNumber.substr(1);
    } else {
      mobileNumber = data.mobileNumber;
    }

    if (!this.props.hasParams) {
      data.interests.map(interest => {
        return dataArray.push(interest.id);
      });
      countryCodes = `+${this.state.countryCode}${mobileNumber}`;
    } else if (this.state.countryCode == null && this.props.hasParams) {
      data.interests.map(interest => {
        return dataArray.push(interest.id);
      });
      countryCodes = `+${mobileNumber}`;
    } else {
      data.interests.map(interest => {
        return dataArray.push(interest.id);
      });
      countryCodes = `+${mobileNumber}`;
    }

    let newRefineData = {
      ...data,
      mobileNumber: countryCodes,
      interests: dataArray,
    };

    let requestBody = this.createRequest(newRefineData);

    this.props.submitAction(requestBody);
  };
  //====================TOUR GUIDE SECTION======
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.startJoyRideAtDataTable();
      }
    }
  };

  render() {
    const { canSubmit, run, steps, stepIndex } = this.state;
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      InstructorInterests,
    } = this.props;

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Row>
          <Col>
            <Card>
              <CardHeader>
                {hasParams ? "Edit" : "Create"} Instructor
              </CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>{error.message}</p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                <Formsy
                  ref="instructorForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="firstName"
                    value={
                      selectedRow && hasParams ? selectedRow.firstName : null
                    }
                    required
                    disabled={submitting}
                    title="First Name"
                    validations={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <TextInput
                    name="lastName"
                    value={
                      selectedRow && hasParams ? selectedRow.lastName : null
                    }
                    required
                    disabled={submitting}
                    title="Last Name"
                    validations={{
                      minLength: 3,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <TextInput
                    name="emailAddress"
                    value={
                      selectedRow && hasParams ? selectedRow.emailAddress : null
                    }
                    required
                    disabled={submitting}
                    title="Email"
                    validations={{
                      isEmail: true,
                      maxLength: 50,
                    }}
                    validationErrors={{
                      isEmail: "Enter valid email",
                      maxLength: "Maximum of 50 characters allowed",
                    }}
                  />
                  <PhoneInput
                    name="mobileNumber"
                    required
                    value={
                      selectedRow && hasParams
                        ? `+${selectedRow.mobileNumber}`
                        : null
                    }
                    disabled={submitting}
                    title="Mobile Number"
                    validations={{
                      minLength: 3,
                      PhoneNumber: true,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      PhoneNumber: "Invalid phone number *",
                    }}
                    getCountryCode={this.getCountryCode}
                    hasParams={hasParams}
                  />
                  <TextInput
                    name="businessName"
                    required
                    value={
                      selectedRow && hasParams ? selectedRow.businessName : null
                    }
                    disabled={submitting}
                    title="Business Name"
                    validations={{
                      minLength: 5,
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                    }}
                  />
                  <InterestDropdown
                    isMulti={true}
                    value={
                      InstructorInterests && InstructorInterests.length
                        ? InstructorInterests
                        : null
                    }
                    isRequired={true}
                    disabled={submitting}
                    innerRef={c => {
                      this.interestRef = c;
                    }}
                    defaultOptions={InstructorInterests}
                    name="interests"
                  />
                  <Button
                    type="submit"
                    color="primary"
                    disabled={!canSubmit || submitting}
                    className={"joyride8"}
                  >
                    {submitting ? (
                      <Spinner size="sm" />
                    ) : (
                      <span>
                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                      </span>
                    )}
                  </Button>{" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.ClearAll()}
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default InstructorForm;
